import { Typography, Box } from '@mui/material';

export const ItemValue = ({
  label,
  value,
  classNameWrapper,
  sxWrapper
}: {
  label: string;
  value: any;
  classNameWrapper?: string;
  sxWrapper?: any;
}) => {
  return (
    <Box className={classNameWrapper} sx={sxWrapper}>
      {/** Need the break work incase it is one long string with no spaces */}
      <Typography color="primary" sx={{ wordWrap: 'break-word' }}>
        {label}
      </Typography>
      {/** Need the break work incase it is one long string with no spaces */}
      <Typography sx={{ wordWrap: 'break-word' }}>{value}</Typography>
    </Box>
  );
};
